export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.provide('getPlayer', (player?: Player): PlayerHelperPlayer => {
    return getPlayer(player)
  })
})
